export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11465.dc079476.jpg";